var angular = require("angular");
var AngularSetup = require("../common/utils/angular-setup");

require('../common/branding/index.scss');
require("../common/index.scss");
require('./index.scss');



window.$ = window.jQuery = require("jquery");
window.Tether = require("tether");
require("bootstrap");
require('angularjs-google-recaptcha-v3');


require("slick-carousel");
$(document).ready(function(){
  $('.slick-slider').slick({
    arrows: false,
    infinite: true,
    fade:true,
    speed: 2500,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  });
})


var SetupAnalytics = require('../common/analytics');

var setup = module.exports = AngularSetup("public");

setup
.module(require('../common/deps').name)
.module(require('../common/directives').name)
.module(require('./directives/frameContent').name)
.module(require('./directives/iframeonload').name)
.module('fayzaan.gRecaptcha.v3')

setup.state("public", {
  abstract: true,
  template: require("./index.pug")
});


// setup.state('public.application', {
//   url: '/application',
//   template: require('./application/index.pug'),
//   controller: require('./application/index'),
//   controllerAs : 'vm',
// })

setup.state("public.funderRegistration", {
  url: "/funder-registration",
  template: require("./funderRegistration/index.pug"),
  controller: require("./funderRegistration/index"),
  controllerAs: "vm",
  data: {
    authenticate: true,
    claims:[{ type:"user_role", value:"applicant", redirect:'/', bail:true}]
  }
});

setup.state("public.applicantRegistrationQuestions", {
  url: "/applicant-registration-questions",
  template: require("./applicantRegistration/questions.pug"),
  controller: require("./applicantRegistration/questions"),
  controllerAs: "vm",
  data: {
    fullHeader:true,
    authenticate: true,
    claims:[{ type:"user_role", value:"funder", redirect:'/', bail:true}]
  }
});

setup.state("public.applicantRegistrationConfirmed", {
  url: "/applicant-registration-confirmed",
  template: '',
  controller: require("./applicantRegistration/confirmed"),
  controllerAs: "vm",
  data: {
    authenticate: true,
    // loginProcessParams: { isApplicant: true },
    claims:[{ type:"user_role", value:"funder", redirect:'/', bail:true}]
  }
})

setup.state("public.applicantRegistration", {
  url: "/applicant-registration",
  template: require("./applicantRegistration/index.pug"),
  controller: require("./applicantRegistration/index"),
  controllerAs: "vm",
  data: {
    authenticate: true,
    // loginProcessParams: { isApplicant: true },
    claims: [
      { type:"user_role", value:"funder", redirect:'/', bail:true},
      { type:"user_applicant_questions_completed", value:"applicant", state: "public.applicantRegistrationQuestions" }
    ]
  }
});

setup.state("public.fundraiserRegistration", {
  url: "/fundraiser-registration",
  template: require("./fundraiserRegistration/index.pug"),
  controller: require("./fundraiserRegistration/index"),
  controllerAs: "vm",
  data: {
    authenticate: true,
    claims:[{ type:"user_role", value:"applicant", redirect:'/', bail:true}]
  }
});
setup.state("public.search", {
  url: "/search",
  template: require("./search/index.pug"),
  controller: require("./search/index"),
  controllerAs: "vm"
});
setup.state("public.projects", {
  url: "/project",
  template: require("./find-a-project/index.pug"),
  controller: require("./find-a-project/index"),
  controllerAs: "vm",
  data: {
    title: 'Discover Projects In Your Local Community | The Good Exchange'
  }
});
setup.state("public.projectDetails", {
  url: "/project/:applicationUserRef",
  template: require("./find-a-project/project/index.pug"),
  controller: require("./find-a-project/project/index"),
  controllerAs: "vm"
});
setup.state("public.projectDetailsApplicant", {
  url: "/project/:applicationUserRef/:applicantName",
  template: require("./find-a-project/project/index.pug"),
  controller: require("./find-a-project/project/index"),
  controllerAs: "vm"
});
setup.state("public.projectDetailsApplicantProject", {
  url: "/project/:applicationUserRef/:applicantName/:projectName",
  template: require("./find-a-project/project/index.pug"),
  controller: require("./find-a-project/project/index"),
  controllerAs: "vm"
});

setup.state("public.fundraisingProfile", {
  url: "/fundraising-profile/:fundraiserRef",
  template: require("./fundraising-profile/index.pug"),
  controller: require("./fundraising-profile/index"),
  controllerAs: "vm"
});

setup.state("public.fundraisingProfileName", {
  url: "/fundraising-profile/:fundraiserRef/:name",
  template: require("./fundraising-profile/index.pug"),
  controller: require("./fundraising-profile/index"),
  controllerAs: "vm"
});

setup.state("public.fundraisingProfileApplicationUserRef", {
  url: "/fundraising-profile/:fundraiserRef/:name/:applicationUserRef",
  template: require("./fundraising-profile/index.pug"),
  controller: require("./fundraising-profile/index"),
  controllerAs: "vm"
});

setup.state("public.fundraisingProfileApplicationTitle", {
  url: "/fundraising-profile/:fundraiserRef/:name/:applicationUserRef/:projectName",
  template: require("./fundraising-profile/index.pug"),
  controller: require("./fundraising-profile/index"),
  controllerAs: "vm"
});

setup.state("public.fundraiserProfile", {
  url: "/fundraiser/:fundraiserRef",
  template: require("./fundraiser/index.pug"),
  controller: require("./fundraiser/index"),
  controllerAs: "vm"
});

setup.state("public.fundraiserProfileName", {
  url: "/fundraiser/:fundraiserRef/:name",
  template: require("./fundraiser/index.pug"),
  controller: require("./fundraiser/index"),
  controllerAs: "vm"
});

setup.state("public.funders", {
  url: "/funders/:funderRef",
  template: require("./funders/index.pug"),
  controller: require("./funders/index"),
  controllerAs: "vm",
  data: {
    fullHeader:true,
  }
});

setup.state("public.fundersName", {
  url: "/funders/:funderRef/:name",
  template: require("./funders/index.pug"),
  controller: require("./funders/index"),
  controllerAs: "vm",
  data: {
    fullHeader:true,
  }
});

setup.state("public.applicants", {
  url: "/applicants/:userRef",
  template: require("./applicants/index.pug"),
  controller: require("./applicants/index"),
  controllerAs: "vm",
  data: {
    fullHeader:true,
  }
});

setup.state("public.applicantsName", {
  url: "/applicants/:userRef/:name",
  template: require("./applicants/index.pug"),
  controller: require("./applicants/index"),
  controllerAs: "vm",
  data: {
    fullHeader:true,
  }
});

setup.state("public.tour", {
  url: "/tour",
  template: require("./tour/index.pug"),
  controller: require("./tour/index"),
  controllerAs: "vm",
  data: {
    fullHeader:true,
  }
});
setup.state("public.tour-two", {
  url: "/tour-two",
  template: require("./tour-two/index.pug"),
  controller: require("./tour-two/index"),
  controllerAs: "vm",
  data: {
    fullHeader:true,
  }
});

setup.auth(require("./auth"));

// init app module
var app = setup.done();

app.config(function($anchorScrollProvider){
  $anchorScrollProvider.disableAutoScrolling()
})

SetupAnalytics(app);
